class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15c1.654 0 3.069-.589 4.24-1.76C13.411 12.069 14 10.654 14 9V3L8 1 2 3v6c0 1.654.586 3.069 1.757 4.24C4.93 14.411 6.343 15 8 15Zm0-1.126c-1.346 0-2.494-.477-3.446-1.431C3.6 11.49 3.123 10.343 3.123 9V3.843L8 2.123l4.874 1.72V9c0 1.343-.477 2.491-1.431 3.443-.952.954-2.1 1.431-3.443 1.431Zm-.454-3.243 4.257-4.228-.809-.766L7.546 9.06 5.52 7.043l-.791.763 2.817 2.825Z"></path></svg>';
  }
}
const e = "pi-mod-compliance";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
